module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-MediumItalic-1a9da2c4b2905d2b9c2e2e02da2575cf.otf";